// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"96453769","487":"6706ea83","980":"e29f46d3"}[chunkId] + ".chunk.js";
};